import type { RoomDirectory } from '@brush/api-client';

/**
 * Direction C — "The Rail", on-air side.
 *
 * The portal runs the same graphics package as room-web with the ground inverted: charcoal
 * where the gallery is chalk. Every view reads its colours from here, so this object is the
 * whole palette for the app.
 *
 * `accent` is fixed to the signal orange rather than taking the room's `accentColor`, and
 * that is deliberate. On this side of the glass orange means "this is you" — your row, your
 * rank, your lineup — and it is never attached to a control. Letting each room re-point it
 * would turn a semantic into decoration and the signal would stop reading. Room identity
 * still shows through `primary`, which carries the room's own colour on its mark.
 */
export interface PortalTheme {
  bg: string;
  panel: string;
  panelLight: string;
  border: string;
  primary: string;
  accent: string;
  text: string;
  textMuted: string;
}

export function themeFor(room: RoomDirectory | null): PortalTheme {
  return {
    bg: '#1f2227',
    panel: '#272b31',
    panelLight: '#31363d',
    border: '#3a3f46',
    /* The room's own colour, worn on its mark. */
    primary: room?.primaryColor || '#e4572e',
    /* "This is you." Fixed by the direction — see the note above. */
    accent: '#e4572e',
    text: '#f2f2ee',
    textMuted: '#9ea3a0',
  };
}
